export default __webpack_public_path__ + "static/media/panel.e45aa142.jpg";